import { Component } from '@angular/core';
import { MdbTableModule } from 'mdb-angular-ui-kit/table';
import { MdbButtonComponent } from '../../../utils/mdb-button/mdb-button.component';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MdbScrollbarModule } from 'mdb-angular-ui-kit/scrollbar';
import { TranslateModule } from '@ngx-translate/core';
import { MdbCheckboxModule } from 'mdb-angular-ui-kit/checkbox';
import { MdbFileUploadModule } from 'mdb-angular-file-upload';
import { TableComponent } from '../../../utils/table/table.component';
import { TableColumnModel } from '../../../../models/table-column.model';
import { ApiInterfaceModel } from '../../../../models/resources/api-interface.model';
import { ApiInterfaceService } from '../../../../services/resources/api-interface.service';
import { CustomNotificationService } from '../../../../services/utils/custom-notification.service';
import { HttpErrorsService } from '../../../../services/utils/http-errors.service';
import { AResourceTableComponent } from '../../../AResourceTableComponent';
import { FormGroupHelper } from '../../../../helpers/form-group-helper';

@Component({
  selector: 'app-api-interfaces-table',
  imports: [
    MdbTableModule,
    MdbButtonComponent,
    ReactiveFormsModule,
    MdbScrollbarModule,
    TranslateModule,
    MdbCheckboxModule,
    MdbFileUploadModule,
    TableComponent
  ],
  template: `
    <app-table
      [columns]="tableColumns"
      [data]="models()"
      [filterFormGroup]="filterFormGroup"
      [loading]="apiInterfaceService.loading()"
      (doFilterRequest)="apiInterfaceService.getAll($event)"
      (urlParamsChange)="this.urlParams = $event"
      [hasActiveFilters]="apiInterfaceService.apiResponse().filters != undefined"
      [pagination]="apiInterfaceService.paginationMeta()"
      [deleteLoadingIds]="this.deleteLoadingIds()"
    ></app-table>
  `,
  standalone: true,
  styles: ``
})
export class ApiInterfacesTableComponent extends AResourceTableComponent<ApiInterfaceModel> {
  filterFormGroup: FormGroup = FormGroupHelper.createFilterFormGroup(this.formBuilder,
    [
      'name'
    ]
  );

  tableColumns: TableColumnModel[] = [
    {
      name: 'NAME',
      selector: [{ selector: 'name' }],
      filterFormControl: this.filterFormGroup.get('name'),
      filterFormControlLabel: 'NAME',
      filterUrlParam: 'name'
    },
    {
      name: 'API_INTERFACES.API_TOKEN',
      selector: [{ selector: 'apiToken' }],
    },
    {
      name: 'API_INTERFACES.ERP_URL',
      selector: [{ selector: 'erpUrl' }],
    },
    {
      buttons: [
        {
          iconClass: 'fas fa-external-link-alt fa-lg',
          floating: true,
          outlined: true,
          isObjectLink: true,
          objectBaseLink: '/api-interfaces'
        },
        {
          iconClass: 'fas fa-trash fa-lg',
          floating: true,
          outlined: true,
          color: 'danger',
          isDelete: true,
          onClick: ($event) => this.delete($event)
        }
      ]
    }
  ];

  constructor(
    formBuilder: FormBuilder,
    public apiInterfaceService: ApiInterfaceService,
    httpErrorsService: HttpErrorsService,
    notificationService: CustomNotificationService
  ) {
    super(formBuilder, apiInterfaceService, httpErrorsService, notificationService, 'API_INTERFACES');
  }
}
